import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/AuthForm.css';
import API_BASE from '../../utils/api.js';
import notify from '../../utils/notify';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSendCode(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (!res.ok) {
        notify(data.error || 'Could not send reset link.');
        return;
      }

      notify('Check your email for a password reset link.');
      navigate('/');
    } catch (err) {
      console.error(err);
      notify('Something went wrong.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-form">
      <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />

      <form className="auth-card" onSubmit={handleSendCode}>
        <h2>Forgot Password</h2>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '8px' }}>
          Enter your email and we'll send you a reset link.
        </p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>

        <p>
          Back to <Link to="/">Log In</Link>
        </p>
      </form>
    </div>
  );
}

export default ForgotPassword;
